import supportModule from '../supportModule';

function sierraSdkLoader() {
  'ngInject';
  return {
    restrict: 'E',
    scope: { onLoad: '&' },
    link: function (scope, element, attrs) {
      var script = document.createElement('script');
      script.type = 'module';
      const isProd = !String(location.origin).includes('sitetest'); // ST1 should fully mirror PROD, but not mirroring now since ST1 is our public staging env for backend
      // TODO(mhowell): only return agent id below from return of initial client eligibility call (from www)
      script.src = isProd
        ? 'https://sierra.chat/agent/aILDKx0Bi89bqqcBi8-TXIjveFK6wNQiYfImlMfnNss/embed'
        : 'https://sierra.chat/agent/aILDKx0Bi89bqqcBi8-TXIjveFK6wNQiYfImlMfnNss/embed/QA';
      script.onload = function () {
        scope.$apply(function () {
          scope.onLoad();
        });
      };
      document.head.appendChild(script);
    }
  };
}

supportModule.directive('sierraSdkLoader', sierraSdkLoader);

export default sierraSdkLoader;
